<script setup lang="ts">
import { useBreakpoints, breakpointsTailwind } from '@vueuse/core'

const breakpoints = useBreakpoints(breakpointsTailwind)
const isDesktop = breakpoints.greaterOrEqual('lg')

const props = defineProps<{
  title?: string
}>()

const open = defineModel<boolean>()

function handleClose() {
  open.value = false
}

/* const componentType = computed(() => {
  return isDesktop.value ? UModal : UDrawer
}) */
</script>

<template>
  <UModal
    v-if="isDesktop"
    v-model:open="open"
  >
    <template #content>
      <div class="p-4">
        <h2
          v-if="props.title"
          class="text-lg font-bold mb-4"
        >
          {{ props.title }}
        </h2>
        <slot />
      </div>
    </template>
  </UModal>
  <StickyContainer
    v-else-if="!isDesktop && open"
    v-model:open="open"
    side="bottom"
    dismissable
    @close="handleClose"
  >
    <slot />
  </StickyContainer>
</template>
